import React from 'react';
import {
  UserIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  QuestionMarkCircleIcon,
  ArrowLeftOnRectangleIcon,
} from '@heroicons/react/24/outline';
import UserMenuHeader from './UserMenuHeader';
import UserMenuItem from './UserMenuItem';

function UserMenuDropdown({
  userName = '',
  userEmail = '',
  onNavigate = () => {},
  onLogout = () => {},
  onClose = () => {},
}) {
  const handleNavigate = (route) => {
    onNavigate(route);
    onClose();
  };

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  return (
    <div className="mp-user-menu__card">
      <UserMenuHeader userName={userName} userEmail={userEmail} />

      <div className="mp-user-menu__body">
        <UserMenuItem icon={UserIcon} label="Meu Perfil" onClick={() => handleNavigate('settings')} />
        <UserMenuItem icon={Cog6ToothIcon} label="Configurações" onClick={() => handleNavigate('settings')} />
        <UserMenuItem icon={CreditCardIcon} label="Planos e Pagamento" onClick={() => handleNavigate('plans')} />
        <UserMenuItem icon={QuestionMarkCircleIcon} label="Ajuda e Suporte" onClick={() => handleNavigate('help')} />
        <UserMenuItem icon={ArrowLeftOnRectangleIcon} label="Sair" onClick={handleLogout} danger />
      </div>
    </div>
  );
}

export default UserMenuDropdown;